/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import React from "react";
import { object, arrayOf, bool, string } from "prop-types";
import { ThingsToDoCards } from "./Cards";
import useNexusFetchHook from "../../../utils/useNexusFetchHook";

const ThingsToDoCardsConnector = ({
	excursionData,
	location,
	isDetailsModal,
	locale,
	destinationCode,
}) => {
	const { excursionCardData } = useNexusFetchHook(destinationCode, isDetailsModal, excursionData);

	if (excursionData.length > 0) {
		return (
			<ThingsToDoCards
				cards={[...excursionData]}
				location={location}
				isDetailsModal={isDetailsModal}
				locale={locale}
			/>
		);
	}

	return (
		<ThingsToDoCards
			cards={[...excursionCardData]}
			location={location}
			isDetailsModal={isDetailsModal}
			locale={locale}
		/>
	);
};

ThingsToDoCardsConnector.propTypes = {
	excursionData: arrayOf(object),
	location: object,
	isDetailsModal: bool,
	locale: string,
	destinationCode: string.isRequired,
};

ThingsToDoCardsConnector.defaultProps = {
	excursionData: [],
	location: object,
	isDetailsModal: false,
	locale: "en-CA",
};

export default ThingsToDoCardsConnector;
export { ThingsToDoCardsConnector };
